import { ComponentType } from 'react';
import { RouteProps } from 'react-router';

export type IRoute = Exclude<RouteProps, { component: any }> & {
  component: ComponentType<any>;
};

export { default as auth } from './auth';
export { default as admin } from './admin';



// WEBPACK FOOTER //
// ./src/routes/index.ts